import React from 'react';

const Program = () => {
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const benefits = [
    "Zero upfront development cost for qualified startups",
    "Revenue-based payment plans",
    "Technical mentorship and business guidance",
    "Priority access to our development team"
  ];

  return (
    <section id="program" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl p-10 shadow-lg">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Student & Startup Program</h2>
              <p className="text-gray-700 mb-6">
                We believe in supporting the next generation of innovators. Our special program for students and early-stage startups offers significant advantages to help you get your idea off the ground.
              </p>
              
              <div className="space-y-4 mb-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mr-2 mt-0.5">
                      <i className="ri-check-line ri-lg text-primary"></i>
                    </div>
                    <p className="text-gray-700">{benefit}</p>
                  </div>
                ))}
              </div>
              
              <button 
                onClick={() => scrollToSection('#contact')}
                className="inline-block px-8 py-3 bg-primary text-white font-medium !rounded-button hover:bg-primary/90 transition-all transform hover:-translate-y-1 shadow-md hover:shadow-lg whitespace-nowrap"
              >
                Apply Now
              </button>
            </div>
            
            <div className="hidden md:block">
              <img 
                src="/images/program/student-entrepreneurs.jpg" 
                alt="Student Entrepreneurs" 
                className="rounded-lg shadow-lg object-cover w-full h-full object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program;
